export const HAS_Z_CODE_PRODUCT_TAG = "x-has-z-product"
export const Z_CODE_PRODUCT_TAG = "x-is-z-product"

export const getZCodeCartQuantity = (zId: string) => {
  return window?.cart?.items?.find(item => item.variant_id.toString() === zId)?.quantity || 0
}

/**
 * Create an array of Z-Code and current variants to be added to cart based on Z-Code available
 * quantities and quantities existing in cart. Quantities will be fulfilled by Z-Code inventory
 * before current product inventory
 */
export const getCurrentAndZCodeQuantities = (quantityToAdd: number, variantId: string, zId?: string, zQuantity?: number) => {
  let remainingQuantity = quantityToAdd
  const variants: Array<{ id: string, quantity: number, isZCode: boolean }> = []

  // Add available Z-code quantity subtracting quantity already in cart
  if (zId && zQuantity) {
    const zQuantityAvailable = Math.max(zQuantity - getZCodeCartQuantity(zId), 0)

    if (zQuantityAvailable) {
      const quantityToAdd = Math.min(remainingQuantity, zQuantityAvailable)
      variants.push({ id: zId, quantity: quantityToAdd, isZCode: true })
      remainingQuantity -= quantityToAdd
    }
  }

  // remainingQuantity can be zero
  variants.push({ id: variantId, quantity: remainingQuantity, isZCode: false })

  return variants
}
